import axios from 'axios';
import store from '@store/store';
import {logoutUser} from '@store/reducers/auth';
import { toast } from 'react-toastify';
import Translate from '../components/translate/conf';

const instance = axios.create({
    // baseURL: 'http://192.168.0.88/'
});

instance.interceptors.request.use(
    (request) => {
        const {token} = store.getState().auth;
        if (token) {
            request.headers.Authorization = `Bearer ${token}`;
        }
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        if( response.data.err !== undefined && response.data.err === 'Unauthorized access' ){
            toast.error(<Translate transVar='error.SessionExpired' />)
            store.dispatch(logoutUser());
            return Promise.reject(response.data.err)
        }
        return response
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;
